//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import LandingTopBar from '../TopBar/LandingTopBar';
import Footer from '../Footer/Footer';
//  Context
import { useLanguage } from '../../../../../API/Context/LanguageContext';
//  Config
import { footerConfig } from "../Footer/FooterConfig";
import "./BaseLayout.css";
//  ----------      END   IMPORT  BLOCK       ----------

function BaseLayout({ children }) {
  //  Consume context
  const { lan } = useLanguage()
  return (
    <div className="base-layout">
      <LandingTopBar lan={lan} />
      <div className="base-layout-content">
        {children}
      </div>
      <Footer {...footerConfig(lan)} />
    </div>
  );
}

export default BaseLayout;
